import { Module, ActionContext } from 'vuex'
import util from '@/lib/util'
import ajax from '@/lib/ajax'
import CurrentUser from '@/store/models/current-user'
interface AppState {
	// 当前登录人的信息
	user: CurrentUser
}

class AppModule implements Module<AppState, any> {
	namespaced: boolean = true
	state = {
		user: new CurrentUser(),
	}
	mutations = {
		setUser(state: AppState, payload: CurrentUser) {
			state.user = payload
		},
	}
	actions = {
		async getCurrentUser(context: ActionContext<AppState, any>) {
			if (context.state.user.userName)
				return context.state.user
			return await ajax.get('/getLoginUser').then(rep => {
				context.commit('setUser', rep.data.result)
				return context.state.user
			})
		},
		clearCurrentUser(context: ActionContext<AppState, any>) {
			context.state.user.userName = ''
		}
	}
}
const app = new AppModule()
export default app
